import type { IIcon } from './../Icons/Success/Success'
import type { CellProps } from '../../interfaces'

import { DataIndex, DataIndexUser, StatusIndex } from '../../models/enum'
import ButtonGridStyled from '../Button/ButtonGridStyled'
import Error from '../Icons/Error/Error'

import Pending from './../Icons/Pending/Pending'
import Success from './../Icons/Success/Success'
import Warning from './../Icons/Warning/Warning'
import BrCell from './BrCell/BrCell'
import ButtonCell from './ButtonsCell/ButtonCell'
import CellWithStatus from './CellWithStatus/CellWithStatus'
import CheckBoxCell from './CheckBoxCell/CheckBoxCell'
import DateCell from './DateCell/DateCell'
import DefaultCell from './DefaultCell/DefaultCell'
import MoneyCell from './MoneyCell/MoneyCell'
import PopoverCell from './PopoverCell/PopoverCell'
import TextCell from './TextCell/TextCell'

const DefaultIcon = () => {
  return <></>
}

export const MapCells = new Map<DataIndex, React.FunctionComponent<CellProps>>()
MapCells.set(DataIndex.procTotal, MoneyCell)
MapCells.set(DataIndex.fileTotal, MoneyCell)
MapCells.set(DataIndex.lcrTotal, MoneyCell)
MapCells.set(DataIndex.lcrVoided, MoneyCell)
MapCells.set(DataIndex.lcrNet, MoneyCell)
MapCells.set(DataIndex.claimDol, MoneyCell)
MapCells.set(DataIndex.groupName, CellWithStatus)
MapCells.set(DataIndex.actions, ButtonCell)
MapCells.set(DataIndex.download, ButtonGridStyled)
MapCells.set(DataIndex.notes, PopoverCell)
MapCells.set(DataIndex.amount, MoneyCell)
MapCells.set(DataIndex.payee, TextCell)
MapCells.set(DataIndex.filenamesList, DefaultCell)
MapCells.set(DataIndex.checkAmount, MoneyCell)
MapCells.set(DataIndex.checkRunDay, BrCell)
MapCells.set(DataIndex.eventDate, DateCell)

export const MapStatus = new Map<StatusIndex, React.FunctionComponent<IIcon>>()
MapStatus.set(StatusIndex.success, Success)
MapStatus.set(StatusIndex.error, Error)
MapStatus.set(StatusIndex.warning, Warning)
MapStatus.set(StatusIndex.pending, Pending)

export function getStatus(status: string) {
  const component = MapStatus.get(StatusIndex[status as keyof typeof StatusIndex])
  return component ?? DefaultIcon
}
export function getComponentForCellProps(key: string) {
  if (key === DataIndex.actions && MapCells.has(DataIndex[key as keyof typeof DataIndex])) {
    const component = MapCells.get(DataIndex[key as keyof typeof DataIndex])
    return component ?? TextCell
  } else {
    const component = MapCells.get(DataIndex[key as keyof typeof DataIndex])
    return component ?? TextCell
  }
}
// users
export const MapCellsUser = new Map<DataIndexUser, React.FunctionComponent<CellProps>>()
MapCellsUser.set(DataIndexUser.L001, CheckBoxCell)
MapCellsUser.set(DataIndexUser.L002, CheckBoxCell)
MapCellsUser.set(DataIndexUser.L003, CheckBoxCell)
MapCellsUser.set(DataIndexUser.groups, CheckBoxCell)
MapCellsUser.set(DataIndexUser.actions, ButtonCell)

export function getComponentForUser(key: string) {
  const component = MapCellsUser.get(DataIndexUser[key as keyof typeof DataIndexUser])
  return component ?? TextCell
}
// extra props
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function addExtraProps(Component: any, extraProps: any) {
  return <Component.type {...Component.props} {...extraProps}></Component.type>
}

export default Map
